import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Ban, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/customers`;

export const BlacklistDialog = ({ order, open, onClose, onSaved }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const c = order?.customer || {};
  const save = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/blacklist`, {
        reason, name: c.name, phone: c.phone_1 || c.phone_2, email: c.email,
        order_id: order?._gomag_number || order?.id, platform: order?._integration_key,
      });
      toast.success("Client adăugat în blacklist");
      setReason("");
      onSaved?.(r.data);
      onClose();
    } catch (e) { toast.error(e.response?.data?.detail || e.message); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="blacklist-dialog" className="border-zinc-800 bg-zinc-950 text-zinc-100 sm:max-w-md" onClick={(e) => e.stopPropagation()}>
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Ban className="h-4 w-4 text-rose-400" />Adaugă în blacklist</DialogTitle></DialogHeader>
        <p className="text-xs text-zinc-400">{c.name || "Client"} · {c.phone_1 || c.phone_2 || "fără telefon"}{c.email ? ` · ${c.email}` : ""}</p>
        <textarea data-testid="blacklist-reason-input" value={reason} onChange={(e) => setReason(e.target.value)} rows={4} autoFocus
          placeholder="Motivul (ex. a refuzat 2 colete, comportament abuziv…)"
          className="w-full rounded-md border border-zinc-800 bg-zinc-900 px-3 py-2 text-sm text-zinc-100" />
        <div className="flex justify-end gap-2">
          <button onClick={onClose} data-testid="blacklist-cancel-btn" className="rounded-md border border-zinc-700 px-3 py-1.5 text-xs text-zinc-300">Renunță</button>
          <button onClick={save} disabled={busy || !reason.trim()} data-testid="blacklist-save-btn"
            className="inline-flex items-center gap-1.5 rounded-md bg-rose-600 px-3 py-1.5 text-xs font-medium text-white disabled:opacity-40">
            {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}Adaugă în blacklist
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const BlacklistBadge = ({ bl, testId }) => (
  <span data-testid={testId} title={`Blacklist: ${bl.reason}`}
    className="inline-flex items-center gap-1 rounded border border-rose-500/50 bg-rose-500/15 px-1 py-px text-[9px] font-bold uppercase text-rose-300">
    <Ban className="h-2.5 w-2.5" />Blacklist
  </span>
);
